import { useMemo } from "react";
import { MRT_ColumnDef } from "material-react-table";
import { TableSorting } from "@/components/elements/Table";
import { EMPTY_STR } from "@/constants/string";
import { TCompanyForReportOutputDto } from "@/api/services/main/learning-progress/dtos/get-companies-for-report.dto";
import { formatLearningProgressDateValue } from "@/features/learning-progress/utils/format";

// 全カラムで TableSorting によるソートを有効化。BE 側 SORT_COLUMN_MAP の sort key と一致させる必要あり。
export const useReportColumns = (): MRT_ColumnDef<TCompanyForReportOutputDto>[] => {
  return useMemo<MRT_ColumnDef<TCompanyForReportOutputDto>[]>(
    () => [
      {
        header: "管理番号",
        accessorKey: "managementNumber",
        size: 120,
        Header: <TableSorting name="company.managementNumber">管理番号</TableSorting>,
        Cell: ({ row }) => row.original.managementNumber || EMPTY_STR.TEXT,
      },
      {
        header: "所属機関名",
        accessorKey: "companyName",
        size: 444,
        Header: <TableSorting name="company.companyName">所属機関名</TableSorting>,
        Cell: ({ row }) => row.original.companyName || EMPTY_STR.TEXT,
      },
      {
        header: "連絡担当者",
        accessorKey: "contactPersonName",
        size: 134,
        Header: <TableSorting name="company.contactPersonName">連絡担当者</TableSorting>,
        Cell: ({ row }) => row.original.contactPersonName || EMPTY_STR.TEXT,
      },
      {
        header: "利用開始日",
        accessorKey: "startDate",
        size: 134,
        Header: <TableSorting name="company.startDate">利用開始日</TableSorting>,
        Cell: ({ row }) => formatLearningProgressDateValue(row.original.startDate),
      },
      {
        header: "対象者数",
        accessorKey: "activeLearnerCount",
        size: 120,
        Header: <TableSorting name="activeLearnerCount">対象者数</TableSorting>,
        Cell: ({ row }) => row.original.activeLearnerCount ?? 0,
      },
      {
        accessorKey: "lastExportedReportAt",
        header: "前回出力日",
        size: 70,
        Header: <TableSorting name="lastExportedReportAt">前回出力日</TableSorting>,
        Cell: ({ row }) => formatLearningProgressDateValue(row.original.lastExportedReportAt),
      },
    ],
    [],
  );
};
